import { reportingService } from '../_services';

const getDefaultState = () => {
  return {
    history: {},
    loading: false
  }
}

export const reportings = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getUserHistory({ commit }, params) {
      commit('getUserHistoryRequest');
      reportingService.getUserHistory(params)
      .then(
          history => commit('getUserHistoryRequestSuccess', history),
          error => commit('getUserHistoryRequestFailure', error)
      );
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getUserHistoryRequest(state) {
      state.loading = true;
    },
    getUserHistoryRequestSuccess(state, history) {
      state.history = history;
      state.loading = false;
    },
    getUserHistoryRequestFailure(state, error) {
        state.history = { error };
        state.loading = false;
    }
  }
}